/** Shared imagery & theme for public marketing pages (/home, /contact-sales). */
export const PUBLIC_THEME = {
  ink: '#344767',
  inkDeep: '#21243d',
  muted: '#8392ab',
  primary: '#5e72e4',
  primary2: '#825ee4',
  accent: '#11cdef',
  success: '#2dce89',
  border: '#e9ecef',
  bgSoft: '#f8f9fe',
  gradient: 'linear-gradient(135deg, #344767 0%, #21243d 55%, #3d4ea8 100%)',
  gradientBtn: 'linear-gradient(135deg, #5e72e4, #825ee4)',
};

export const PUBLIC_IMAGES = {
  hero:
    'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=85',
  heroBg:
    'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1800&q=80',
  heroAccent:
    'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=700&q=80',
  skyline:
    'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80',
  team:
    'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=900&q=80',
  property:
    'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=900&q=80',
  mobile:
    'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=800&q=80',
  contact:
    'https://images.unsplash.com/photo-1560179707-f14e90ef3623?auto=format&fit=crop&w=1000&q=80',
};

export const INTEGRATION_PILLS = [
  { icon: 'fab fa-facebook', label: 'Meta Lead Ads', tone: '#1877f2' },
  { icon: 'fab fa-instagram', label: 'Instagram leads', tone: '#e4405f' },
  { icon: 'fas fa-file-excel', label: 'Excel import', tone: '#16a34a' },
  { icon: 'fab fa-whatsapp', label: 'WhatsApp follow-up', tone: '#25d366' },
];

export const TRUST_STATS = [
  { value: '12+', label: 'CRM modules' },
  { value: 'Multi', label: 'Tenant SaaS' },
  { value: '24/7', label: 'Lead capture' },
  { value: '360°', label: 'Pipeline view' },
];

export const CONTACT_PERKS = [
  { icon: 'fas fa-rocket', text: 'Fast agency onboarding & workspace setup' },
  { icon: 'fab fa-facebook', text: 'Facebook & Instagram Lead Ads integration help' },
  { icon: 'fas fa-users', text: 'Training for admins and field sales teams' },
  { icon: 'fas fa-chart-line', text: 'Dashboards, reports & follow-up automation' },
];
